export default __webpack_public_path__ + "static/bt_open_house_1-088f11220a8abe1f69c2c0502831a6ac.jpg";